  <div *ngIf="!isFinished && !listData" class="text-center">
    <img class="text-center" src="assets/themes/images/img-video-loader.gif" width="40" height="40" alt="loader">
  </div>
  <div class="leaderboard-container" *ngIf="listData">
    <h3 class="heading-4 leaderboard-heading">{{mls.languageText.leaderboard.key1}}({{playersCount}})</h3>
    <div class="leaderboard-scroll" 
      infiniteScroll nfinite-scroll 
      [infiniteScrollDistance]="5" 
      [infiniteScrollThrottle]="1000"
      infinite-scroll-disabled="busyLoadingData" 
      (scrolled)="onScroll()" [scrollWindow]="false">
      <ul class="board__excellent-players" *ngIf="topScores && false">
        <li *ngFor="let item of topScoresArray; let index = index">
          <app-player 
            [isTopScore]="topScores" 
            [columnCard]="topScoresArray.length" 
            [ranking]="item.rank"
            [playerObj]="item" 
            (navigateToProfile)="navigateToProfile($event)">
          </app-player>
        </li>
      </ul>
      <ng-container *ngIf="listData?.leaderboard.length > numbers.ZERO">
        <ul class="leaderboard__players">
          <li *ngFor="let playerObj of listData.leaderboard; let index = index">
            <app-player 
              [isTopScore]="!topScores" 
              [playerObj]="playerObj" 
              [ranking]="playerObj.rank"
              [gameId]="gameId"
              (navigateToProfile)="navigateToProfile($event)">
            </app-player>
          </li>
          <li *ngIf="listData.user_leaderboard" class="current-user">
            <app-player 
              [isTopScore]="!topScores" 
              [playerObj]="listData.user_leaderboard" 
              [ranking]="listData.user_leaderboard.rank"
              (navigateToProfile)="navigateToProfile($event)">
            </app-player>
          </li>
        </ul>
      </ng-container>
    </div>
    <div *ngIf="busyLoadingData" class="leaderboard-loader text-center">
      <img class="text-center" src="assets/themes/images/img-video-loader.gif" width="40" height="40" alt="loader">
    </div>
  </div>